import { useCallback, useState } from 'react';
import store from 'store';

export const STORAGE_KEYS = {
  NOTES_POPUP_SEEN: 'dc_campus_notesPopupSeen',
  NOTES_USED: 'dc_campus_notesUsed',
  LEARN_RECAP_EVER_SEEN: 'dc_campus_learnRecapEverSeen',
  LEARN_RECAP_LAST_SEEN: 'dc_campus_learnRecapLastSeen',
  LEARN_RECAP_SKIP_COUNT: 'dc_campus_learnRecapSkipCount',
  LEARN_RECAP_TMP_DISABLED_UNTIL: 'dc_campus_learnRecapTmpDisabledUntil',
} as const;
type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];

export const useStorage = <T>(
  key: StorageKey,
  defaultValue?: T,
): { setValue: (value: T) => void; value: T } => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = store.get(key);
      return item ?? defaultValue;
    } catch (error) {
      return defaultValue;
    }
  });

  const setValue = useCallback(
    (value: T) => {
      setStoredValue(value);
      store.set(key, value);
    },
    [key],
  );

  return { value: storedValue, setValue };
};
